import defaultSettings from '@/settings.json'

const runtimeSettings =
  typeof window !== 'undefined' && window.__APP_SETTINGS__
    ? window.__APP_SETTINGS__
    : {}

const privateSettingKeys = new Set([
  'KEY_TOKEN_LOGIN',
  'KEY_USER_INFO',
  'KEY_TENANT',
  'KEY_LANG',
])

export const getSetting = (key) => {
  if (privateSettingKeys.has(key)) {
    return defaultSettings[key]
  }
  return runtimeSettings[key] ?? defaultSettings[key]
}

export const baseUrl = () =>
  process.env.NODE_ENV === 'development'
    ? getSetting('devBaseUrl')
    : getSetting('proBaseUrl')

export const messageUrl = () =>
  process.env.NODE_ENV === 'development'
    ? getSetting('devMessageUrl') || getSetting('devBaseUrl')
    : getSetting('proMessageUrl') || getSetting('proBaseUrl')
